var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "shensu-info",
    },
    [
      _c("div", { staticClass: "head-title" }, [_vm._v("变更提成信息")]),
      _c("div", { staticClass: "form-row-2" }, [
        _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "lable" }, [_vm._v("系统判断提成类型为：")]),
          _c("div", { staticClass: "text danger" }, [
            _vm._v(_vm._s(_vm.detail.oldBonusTypeLabel)),
          ]),
        ]),
        _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "lable" }, [_vm._v("客服申请修改为：")]),
          _c("div", { staticClass: "text danger" }, [
            _vm._v(_vm._s(_vm.detail.bonusTypeLabel)),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "shensu-content" }, [
        _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "lable" }, [_vm._v("图片证据：")]),
          _c(
            "div",
            { staticClass: "img-list" },
            _vm._l(_vm.detail.urls, function (url, index) {
              return _c(
                "div",
                { key: index, staticClass: "img" },
                [
                  _c("el-image", {
                    staticClass: "image",
                    attrs: { src: url, fit: "contain" },
                  }),
                  _c("div", { staticClass: "look" }, [_vm._v("查看")]),
                  _c("el-image", {
                    staticClass: "image image-click",
                    attrs: {
                      src: url,
                      fit: "contain",
                      "preview-src-list": _vm.detail.urls,
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]),
        _c("div", { staticClass: "form-row" }, [
          _c("div", { staticClass: "lable" }, [_vm._v("申诉备注：")]),
          _c("div", { staticClass: "text" }, [
            _vm._v(_vm._s(_vm.detail.reason)),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "head-title" }, [_vm._v("是否审核通过")]),
      _c(
        "div",
        { staticClass: "form-row" },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.examine.auditStatus,
                callback: function ($$v) {
                  _vm.$set(_vm.examine, "auditStatus", $$v)
                },
                expression: "examine.auditStatus",
              },
            },
            [
              _c("el-radio", { attrs: { label: "2" } }, [_vm._v("通过")]),
              _c("el-radio", { attrs: { label: "3" } }, [_vm._v("不通过")]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.examine.auditStatus === "3"
        ? _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticClass: "audit_textarea",
                  attrs: { "label-width": "40px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "原因" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入原因",
                          maxlength: "200",
                          "show-word-limit": "",
                          type: "textarea",
                        },
                        model: {
                          value: _vm.examine.auditRemarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.examine, "auditRemarks", $$v)
                          },
                          expression: "examine.auditRemarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.examine.auditStatus === "2"
        ? _c(
            "div",
            [
              _c(
                "el-form",
                {
                  staticClass: "audit_textarea",
                  attrs: { "label-width": "40px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入备注",
                          maxlength: "200",
                          "show-word-limit": "",
                          type: "textarea",
                        },
                        model: {
                          value: _vm.examine.auditRemarks,
                          callback: function ($$v) {
                            _vm.$set(_vm.examine, "auditRemarks", $$v)
                          },
                          expression: "examine.auditRemarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "button-con" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-cancel",
              on: {
                click: function ($event) {
                  return _vm.$emit("dialogVisible")
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              staticClass: "btn-ok",
              attrs: { type: "primary" },
              on: { click: _vm.auditApply },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }